import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./wireBonding.png"

const ワイヤーボンディング = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { wireBonding: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"ワイヤー\nボンディング"}
      src={img}
      helpURL={HELP_LINKS["ワイヤーボンディング"]}
    >
      <RadioGroup name={estimateField.wireBonding.key} selectedValue={values.wireBonding} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["ワイヤーボンディング"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["ワイヤーボンディング"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.wireBonding} />
    </OneClickField>
  )
}

export default ワイヤーボンディング
